<template>
  <div class="content-wrapper" v-if="modalBehavior.showModalMain">
    <!--<save-modal-progress-bar></save-modal-progress-bar>-->

    <form class="form content" @submit.prevent="handleSaveExtraction" ref="save-extraction-form">
      <table class="w-100">
        <tr>
          <th class="text text-center title" colspan="3">Medical Provider Information</th>
        </tr>
        <tr>
          <td class="text text-center subtitle" colspan="3">Link your extraction with a medical provider</td>
        </tr>

        <tr>
          <td><label for="firstName"><span style="color:#ff4444"></span>First Name</label></td>
          <td><label for="lastName"><span style="color:#ff4444">* </span>Last Name</label></td>
        </tr>
        <tr>
          <td><input id="firstName" type="text" name="firstName" v-model="searchNpiForm.first" @keypress="pressToProceed"></td>
          <td><input id="lastName" type="text" name="lastName" v-model="searchNpiForm.last" @keypress="pressToProceed"></td>
        </tr>

        <tr>
          <td><label for="businessName" >Business Name <span title="Where can I find it???"><font-awesome-icon icon="question-circle"/></span></label></td>
          <td><label for="phone">Phone <span title="Where can I find it???"><font-awesome-icon icon="question-circle"/></span></label></td>
        </tr>
        <tr>
          <td><input id="businessName" type="text" name="businessName" v-model="searchNpiForm.business" placeholder="(Optional)" @keypress="pressToProceed"></td>
          <td><input id="phone" type="text" name="phone" v-model="searchNpiForm.phone" placeholder="(Optional)" @keypress="pressToProceed"></td>
        </tr>

        <tr>
          <td><label for="specialty">Specialty <span><font-awesome-icon icon="question-circle"/></span></label></td>
          <td><label for="npi">NPI <span title="a unique 10-digit identification number issued to health care providers in the United States by the Centers for Medicare and Medicaid Services (CMS)."><font-awesome-icon icon="question-circle"/></span></label></td>

        </tr>
        <tr>
          <td><input id="specialty" type="text" name="specialty" v-model="searchNpiForm.specialty" placeholder="(Optional)" @keypress="pressToProceed"></td>
          <td><input id="npi" type="text" name="npi" v-model="searchNpiForm.npi" placeholder="(Optional)" @keypress="pressToProceed"></td>
        </tr>

        <tr>
          <td colspan="3"><small style="color:#ff4444" v-if="modalMainWarning">* Please provide last name</small></td>
        </tr>

      </table>
    </form>
    <div class="modal-footer">
      <button style="opacity: 0">Cancel</button>
      <button type="button" class="btn btn--success" @click="handleSearchNpi">Search</button>
    </div>
    <select class='recents form-select' size="6">
      <option selected>Recent choices...</option>
      <option v v-for="(npi, index) in recentNpis" :key="index" :value="npi.id"
          @click="selectNpi(npi.id)"
          class="list__item capitalize">
        {{npi2string(npi)}}
      </option>
    </select>
  </div>
</template>

<script>
  import {searchNpi} from '@/api/pdfApi';
  import {mapGetters} from 'vuex';
  export default {
    name: "SaveModalMain",
    props: {
      modalBehavior: Object,
    },
    data() {
      return {
        npiSearchResults: Array,
        searchNpiForm: {
          first: '',
          last: '',
          business: '',
          phone: '',
          specialty: '',
          npi: '',
          otherId: ''
        },
        modalMainWarning: false,
        npi : 0
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      recentNpis: function() {
        let ret = {};
        Object.keys(this.allData.npis).forEach((val)=>{
          let _npi = this.allData.npis[val];
          if(_npi.pr && _npi.pr.lst) {
            ret[val] = _npi;
          }
        });
        return ret;
      }
    },
    methods: {
      selectNpi(id) {
        this.npi = id;
        this.$emit('selectNpi', id);
        this.$emit('slideModalTo','categorySearch');
      },
      handleSearchNpi() {
        if (/*this.searchNpiForm.first && */this.searchNpiForm.last) {
          this.$emit('handleSearchNpi', this.searchNpiForm, 'npiSearch');
        }
        else {
          this.modalMainWarning = true;
        }
      },
      pressToProceed(event) {
        if (event.keyCode === 13) {
          this.handleSearchNpi();
        }
      },
      npi2string(npi) {
        if(npi && npi.pr && npi.pr.lst)
          return npi.pr.lst+","+npi.pr.fst;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../stylesheets/modules/extraction-save-modal";
  .recents option:hover {
    background-color: rgb(192,192,192);
  }
</style>